// Norwegian translations
export const noTranslations = {
  common: {
    // Workspace
    "workspace.switchWorkspace": "Bytt arbeidsområde",
    "workspace.switching": "Bytter arbeidsområde...",
    "workspace.switchingTo": "Laster data for {{name}}",
    "workspace.workspaces": "Arbeidsområder",
    "workspace.role.owner": "Eier",
    "workspace.role.admin": "Administrator",
    "workspace.role.editor": "Redaktør",
    "workspace.role.viewer": "Leser",
    "workspace.noPermission": "Du har ikke tillatelse til å utføre denne handlingen",
    "workspace.members": "Medlemmer",
    "workspace.members.active": "Aktive medlemmer",
    "workspace.members.count": "medlem(mer)",
    "workspace.members.description": "Administrer hvem som har tilgang til dette arbeidsområdet.",
    "workspace.members.empty": "Ingen medlemmer funnet.",
    "workspace.members.roleUpdated": "Medlemsrolle oppdatert",
    "workspace.members.removed": "Medlem fjernet",
    "workspace.members.remove": "Fjern",
    "workspace.inviteMembers": "Inviter medlemmer",
    "workspace.manageMembers": "Administrer medlemmer",
    "workspace.invite.title": "Inviter til arbeidsområde",
    "workspace.invite.description": "Inviter noen til å bli med i arbeidsområdet ditt.",
    "workspace.invite.role": "Arbeidsområderolle",
    "workspace.invite.roleDescription": "Dette bestemmer hva brukeren kan gjøre i dette arbeidsområdet.",
    "workspace.invite.message": "Personlig melding",
    "workspace.invite.messagePlaceholder": "Legg til en personlig melding...",
    "workspace.invite.sending": "Sender...",
    "workspace.invite.send": "Send invitasjon",
    "workspace.invite.sent": "Invitasjon sendt",
    "workspace.invite.alreadyInvited": "Denne e-posten er allerede invitert til dette arbeidsområdet",
    "workspace.invite.pending": "Ventende invitasjoner",
    "workspace.invite.expires": "Utløper",
    "workspace.invite.resend": "Send på nytt",
    "workspace.invite.resent": "Invitasjon sendt på nytt",
    "workspace.invite.revoke": "Tilbakekall",
    "workspace.invite.revoked": "Invitasjon tilbakekalt",

    // Hero section
    "hero.title": "Ta kontroll over kontraktene dine",
    "hero.subtitle": "Forenkle kontraktsadministrasjon med vår kraftige løsning. Få full oversikt, reduser kostnader og gå aldri glipp av en utløpsdato.",
    "hero.companyTitle": "Slutt å tape penger på glemte kontrakter",
    "hero.companySubtitle": "Subtrackr gir deg full kontroll over alle kontraktene dine. Få automatiske påminnelser, spor utgifter, og gå aldri glipp av en fornyelsesdato igjen.",
    "hero.badge": "🎉 Gratis plan for alltid",
    "hero.benefit1": "Gå aldri glipp av en fornyelsesdato",
    "hero.benefit2": "Spor alle kontraktskostnader på ett sted",
    "hero.benefit3": "Spar 15% på kontraktskostnader i snitt",
    "hero.getStarted": "Kom i gang gratis",
    "hero.watchDemo": "Se hvordan det fungerer",
    "hero.neverMiss": "Gå aldri glipp av en utløpsdato",
    "hero.trustBadge1": "GDPR-kompatibel",
    "hero.trustBadge2": "Gratis plan tilgjengelig",
    "hero.reminderCard": "Påminnelse sendt!",
    "hero.reminderCardSub": "Kontrakt utløper om 30 dager",

    // Stats section - Product benefits, not fake customer stats
    "stats.contractsValue": "∞",
    "stats.contractsLabel": "Ubegrensede kontrakter",
    "stats.remindersValue": "30+",
    "stats.remindersLabel": "Dager forhåndsvarsel",
    "stats.securityValue": "100%",
    "stats.securityLabel": "Sikker og GDPR-kompatibel",
    "stats.setupValue": "2 min",
    "stats.setupLabel": "Rask oppsett",

    // How It Works section
    "howItWorks.badge": "Enkelt å komme i gang",
    "howItWorks.title": "Slik fungerer det",
    "howItWorks.subtitle": "Kom i gang på minutter og ta kontroll over kontraktene dine",
    "howItWorks.step1.title": "Legg til kontraktene dine",
    "howItWorks.step1.description": "Last opp PDF-er eller skriv inn kontraktsdetaljer manuelt. Vår AI kan hente ut nøkkelinformasjon automatisk.",
    "howItWorks.step2.title": "Få smarte påminnelser",
    "howItWorks.step2.description": "Motta e-postvarsler før fornyelser og frister. Gå aldri glipp av en viktig dato igjen.",
    "howItWorks.step3.title": "Spar tid og penger",
    "howItWorks.step3.description": "Spor kostnader, finn sparemuligheter, og ta informerte beslutninger med kraftig analyse.",

    // Features section
    "features.badge": "Kraftige funksjoner",
    "features.title": "Alt du trenger for full kontroll",
    "features.subtitle": "Fra enkel kontraktssporing til AI-drevne innsikter – Subtrackr har alle verktøyene du trenger",
    "features.cta": "Se alle funksjoner",
    
    "features.contractManagement.title": "Kontraktsadministrasjon",
    "features.contractManagement.description": "Lagre, organiser og søk i alle kontraktene dine på ett sikkert sted. Mist aldri oversikten over viktige dokumenter igjen.",
    
    "features.reminders.title": "Smarte påminnelser",
    "features.reminders.description": "Få automatiske e-postvarsler før fornyelser og frister. Slutt å betale for kontrakter du ikke trenger.",
    
    "features.dashboards.title": "Kraftig analyse",
    "features.dashboards.description": "Visuelle dashbord som viser kontraktsstatus, kostnader og trender. Ta datadrevne beslutninger om kontraktene dine.",
    
    "features.aiPowered.title": "AI-drevne innsikter",
    "features.aiPowered.description": "La AI analysere kontraktene dine for kostnadsoptimalisering og risikovurdering. Hent ut data fra PDF-er automatisk.",
    
    "features.integrations.title": "ERP-integrasjoner",
    "features.integrations.description": "Koble til Tripletex, Finago og andre systemer. Synkroniser utgifter automatisk og oppdage gjentakende betalinger.",
    
    "features.dataHealth.title": "Overvåking av datakvalitet",
    "features.dataHealth.description": "Spor datakvaliteten på tvers av alle kontrakter. Få anbefalinger for å forbedre kontraktsdatabasen din.",

    // Pricing section
    "pricing.title": "Enkel, transparent prising",
    "pricing.subtitle": "Velg en plan som passer dine behov. Oppgrader eller nedgrader når som helst.",
    "pricing.perMonth": "/måned",
    "pricing.mostPopular": "Mest populær",
    "pricing.question": "Trenger du hjelp til å velge?",
    "pricing.contactUs": "Kontakt oss",
    "pricing.customPlan.title": "Bygg din egen plan",
    "pricing.customPlan.description": "Passer ingen av standardplanene våre? Lag et fullt tilpasset abonnement ved å velge kun funksjonene du trenger. Betal kun for det du bruker.",
    "pricing.customPlan.badge1": "Fleksibel prising",
    "pricing.customPlan.badge2": "Velg funksjoner",
    "pricing.customPlan.badge3": "Endre når som helst",
    "pricing.customPlan.button": "Lag tilpasset plan",
    
    "customPlan.signUpToContinue": "Registrer deg for å fortsette",
    "customPlan.invalidPlanData": "Ugyldige plandata. Vennligst prøv igjen.",
    "customPlan.preparingCheckout": "Forbereder betaling",
    "customPlan.redirectingToPayment": "Omdirigerer deg til sikker betaling...",
    "customPlan.planCreated": "Din tilpassede plan er opprettet!",
    "customPlan.testActivation": "Testaktivering",
    "customPlan.enterTestCode": "Skriv inn testkode",
    "customPlan.activate": "Aktiver",
    "customPlan.invalidTestCode": "Ugyldig testkode",
    "customPlan.selectFeaturesFirst": "Vennligst velg minst én funksjon",
    "customPlan.loginRequired": "Vennligst logg inn for å aktivere abonnementet",
    "customPlan.testActivationSuccess": "Testabonnement aktivert!",
    "customPlan.activationFailed": "Kunne ikke aktivere abonnementet",
    
    // Plan Selection page
    "planSelection.title": "Velg din plan",
    "planSelection.subtitle": "Velg en plan for å komme i gang med Subtrackr",
    "planSelection.selectPlan": "Velg plan",
    "planSelection.haveAccount": "Har du allerede en konto?",
    
    "pricing.starter.name": "Starter",
    "pricing.starter.price": "999 kr",
    "pricing.starter.description": "Perfekt for små bedrifter",
    "pricing.starter.feature1": "Opptil 50 kontrakter",
    "pricing.starter.feature2": "E-postvarsler",
    "pricing.starter.feature3": "Grunnleggende rapportering",
    "pricing.starter.feature4": "24/7 support",
    "pricing.starter.button": "Kom i gang",
    
    "pricing.professional.name": "Professional",
    "pricing.professional.price": "1 999 kr",
    "pricing.professional.description": "Ideell for voksende bedrifter",
    "pricing.professional.feature1": "Ubegrenset antall kontrakter",
    "pricing.professional.feature2": "Avanserte dashbord",
    "pricing.professional.feature3": "Teamsamarbeid",
    "pricing.professional.feature4": "Tilpassede varsler",
    "pricing.professional.feature5": "Prioritert support",
    "pricing.professional.button": "Start gratis prøveperiode",
    
    "pricing.enterprise.name": "Enterprise",
    "pricing.enterprise.price": "3 999 kr",
    "pricing.enterprise.description": "For store organisasjoner",
    "pricing.enterprise.feature1": "Ubegrenset alt",
    "pricing.enterprise.feature2": "Tilpassede integrasjoner",
    "pricing.enterprise.feature3": "Dedikert kontaktperson",
    "pricing.enterprise.feature4": "SLA-garantier",
    "pricing.enterprise.feature5": "Avanserte sikkerhetsfunksjoner",
    "pricing.enterprise.feature6": "On-premises alternativ",
    "pricing.enterprise.button": "Kontakt salg",
    
    // Register page
    "register.selectedPlan": "Valgt plan",
    
    // CTA section
    "cta.title": "Klar til å ta kontroll over kontraktene dine?",
    "cta.subtitle": "Bli med hundrevis av norske bedrifter som sparer tid og penger med smartere kontraktsadministrasjon",
    "cta.getStarted": "Kom i gang gratis",
    "cta.contactSales": "Kontakt salg",
    "cta.benefit1": "Gratis plan for alltid",
    "cta.benefit2": "Ingen kredittkort kreves",
    "cta.benefit3": "Oppsett på 2 minutter",
    "cta.trustNote": "Ingen kredittkort kreves · Gratis plan tilgjengelig · Oppsett på minutter",
    
    // Footer
    "footer.description": "Subtrackr hjelper bedrifter med å ta kontroll over kontraktene sine med kraftige administrasjonsverktøy, påminnelser og analyser.",
    "footer.product": "Produkt",
    "footer.features": "Funksjoner",
    "footer.pricing": "Priser",
    "footer.security": "Sikkerhet",
    "footer.company": "Selskap",
    "footer.about": "Om oss",
    "footer.contact": "Kontakt",
    "footer.privacy": "Personvernpolicy",
    "footer.terms": "EULA",
    "footer.copyright": "© {{year}} Subtrackr. Alle rettigheter reservert.",

    // EULA
    "eula.title": "Sluttbrukerlisensavtale (EULA)",
    "eula.lastUpdated": "Sist oppdatert: Februar 2026",
    "eula.effectiveDate": "Ikrafttredelsesdato: 25. februar 2026",
    "eula.contactText": "Hvis du har spørsmål om denne sluttbrukerlisensavtalen, vennligst kontakt oss på legal@subtrackr.com",
    "eula.subscription.taxes": "Du er ansvarlig for alle gjeldende avgifter, skatter og offentlige gebyrer (unntatt skatt på Subtrackrs nettoinntekt) som oppstår ved din bruk av plattformen. Dersom vi er pålagt å kreve inn eller innbetale slike avgifter på dine vegne, vil det aktuelle beløpet bli fakturert til deg.",
    "eula.indemnification.ipIndemnity": "Subtrackr vil forsvare og holde deg skadesløs mot ethvert tredjepartskrav om at din autoriserte bruk av plattformen krenker en tredjeparts patent, varemerke eller opphavsrett. Dersom et slikt krav oppstår, vil Subtrackr etter eget skjønn enten (a) sikre deg retten til å fortsette å bruke plattformen, (b) modifisere plattformen slik at den ikke er krenkende, eller (c) si opp denne avtalen og gi en forholdsmessig refusjon av forhåndsbetalte avgifter for den gjenværende abonnementsperioden.",
    "eula.aup.title": "17. Retningslinjer for akseptabel bruk",
    "eula.aup.intro": "I tillegg til lisensrestriksjonene i punkt 3, samtykker du i at du ikke vil bruke plattformen til å:",
    "eula.aup.r1": "Laste opp, overføre eller lagre innhold som er ulovlig, ærekrenkende, obskønt, eller krenker tredjeparts rettigheter",
    "eula.aup.r2": "Forstyrre eller avbryte integriteten eller ytelsen til plattformen eller dens underliggende infrastruktur",
    "eula.aup.r3": "Introdusere ondsinnet kode, virus, ormer eller annen programvare beregnet på å skade eller kompromittere plattformen",
    "eula.aup.r4": "Utgi deg for å være en annen person eller enhet, eller gi uriktige opplysninger om din tilknytning til en person eller enhet",
    "eula.aup.r5": "Bruke plattformen til aktiviteter som bryter gjeldende lover eller forskrifter i din jurisdiksjon",
    "eula.aup.enforcement": "Vi forbeholder oss retten til å suspendere eller avslutte din tilgang til plattformen umiddelbart og uten varsel dersom vi fastslår, etter eget skjønn, at du har brutt disse retningslinjene for akseptabel bruk.",
    "eula.warranties.title": "18. Garantier og ansvarsfraskrivelser",
    "eula.warranties.performance": "Subtrackr garanterer at plattformen i abonnementsperioden vil fungere i vesentlig samsvar med publisert dokumentasjon. Dersom du identifiserer en vesentlig avvik, må du varsle oss skriftlig med tilstrekkelig detalj til å reprodusere problemet. Vi vil bruke kommersielt rimelige anstrengelser for å rette avviket. Dersom vi ikke er i stand til å gjøre det innen tretti (30) virkedager, kan du si opp denne avtalen og motta en forholdsmessig refusjon av forhåndsbetalte avgifter for den gjenværende abonnementsperioden.",
    "eula.warranties.maliciousCode": "Vi garanterer at plattformen, så langt vi vet, er fri for virus, skadelig programvare eller annen ondsinnet kode som bevisst er introdusert av oss. Denne garantien omfatter ikke tredjepartsintegrasjoner eller kode introdusert av deg eller andre brukere.",
    "eula.warranties.yourWarranties": "Du garanterer at: (a) du har identifisert deg selv og din organisasjon korrekt under registrering; (b) du har full myndighet til å inngå og oppfylle dine forpliktelser under denne avtalen; og (c) din bruk av plattformen vil være i samsvar med alle gjeldende lover og forskrifter.",
    "eula.warranties.disclaimer": "MED UNNTAK AV DET SOM ER UTTRYKKELIG ANGITT I DETTE AVSNITTET, LEVERES PLATTFORMEN \"SOM DEN ER\" OG \"SOM TILGJENGELIG\" UTEN GARANTIER AV NOE SLAG, VERKEN UTTRYKKELIGE, UNDERFORSTÅTTE ELLER LOVPÅLAGTE, INKLUDERT MEN IKKE BEGRENSET TIL UNDERFORSTÅTTE GARANTIER OM SALGBARHET, EGNETHET FOR ET BESTEMT FORMÅL OG IKKE-KRENKELSE. SUBTRACKR GARANTERER IKKE AT PLATTFORMEN VIL VÆRE UAVBRUTT, FEILFRI ELLER FULLSTENDIG SIKKER.",
    "eula.forceMajeure.title": "19. Force majeure",
    "eula.forceMajeure.text": "Ingen av partene skal holdes ansvarlig for manglende eller forsinket oppfyllelse av sine forpliktelser under denne avtalen der slik svikt skyldes omstendigheter utenfor partens rimelige kontroll, inkludert men ikke begrenset til naturkatastrofer, myndighetshandlinger, pandemier, avbrudd i internettjenester, strømbrudd, cyberangrep eller andre force majeure-hendelser. Den berørte parten skal gi umiddelbart varsel og bruke rimelige anstrengelser for å begrense virkningen av slike hendelser.",
    "eula.assignment.title": "20. Overdragelse og varsler",
    "eula.assignment.restriction": "Ingen av partene kan overdra eller overføre denne avtalen eller noen av sine rettigheter eller forpliktelser uten forutgående skriftlig samtykke fra den andre parten, bortsett fra at begge parter kan overdra denne avtalen i forbindelse med en fusjon, oppkjøp eller salg av hele eller vesentlige deler av sine eiendeler.",
    "eula.assignment.notices": "Varsler under denne avtalen sendes til e-postadressen knyttet til din konto og anses mottatt én (1) virkedag etter sending. Du kan sende varsler til oss på legal@subtrackr.com, som anses mottatt én (1) virkedag etter sending.",
    "eula.dataProcessing.title": "21. Databehandlingsforpliktelser",
    "eula.dataProcessing.role": "Når vi behandler personopplysninger på dine vegne, opptrer Subtrackr som databehandler under gjeldende personvernlovgivning, inkludert GDPR. Vi vil kun behandle personopplysninger i henhold til dine dokumenterte instruksjoner og vil ikke bruke personopplysninger til andre formål enn å levere plattformen.",
    "eula.dataProcessing.subprocessors": "Vi kan engasjere underdatabehandlere for å bistå med leveransen av plattformen. Vi vil opprettholde en liste over nåværende underdatabehandlere og gi deg forhåndsvarsel om nye underdatabehandlere. Du kan protestere mot en ny underdatabehandler på rimelig grunnlag innen ti (10) virkedager etter varsling.",
    "eula.dataProcessing.breach": "Ved brudd på personopplysningssikkerheten vil vi varsle deg uten ugrunnet opphold og senest 72 timer etter at vi ble kjent med bruddet. Vi vil samarbeide med deg for å undersøke og begrense virkningen av ethvert slikt brudd.",
    "eula.dataProcessing.dpa": "Enterprise-kunder kan be om en separat databehandleravtale (DPA) som gir ytterligere detaljer om databehandlingsvilkår, underdatabehandlerlister og mekanismer for grenseoverskridende dataoverføring.",
    "eula.modal.title": "Sluttbrukerlisensavtale",
    "eula.modal.description": "Vennligst les og godta sluttbrukerlisensavtalen vår for å fortsette å bruke Subtrackr.",
    "eula.modal.summary1": "Ved å godta denne EULA-en samtykker du til vilkårene som regulerer din bruk av Subtrackr-plattformen, inkludert lisensrestriksjoner, dataeierskap, betalingsforpliktelser og ansvarsbegrensninger.",
    "eula.modal.summary2": "Du beholder eierskapet til alle data du laster opp til plattformen. Subtrackr beholder alle immaterielle rettigheter til selve plattformen.",
    "eula.modal.summary3": "Denne avtalen er underlagt norsk lov. Den fullstendige avtalen er tilgjengelig for gjennomgang.",
    "eula.modal.checkboxLabel": "Jeg har lest og godtar",
    "eula.modal.eulaLink": "Sluttbrukerlisensavtalen",
    "eula.modal.accept": "Godta og fortsett",
    "eula.modal.accepting": "Godtar...",
    "eula.acceptError": "Kunne ikke registrere godkjennelse. Vennligst prøv igjen.",
    "register.eulaAgree": "Jeg har lest og godtar",
    "register.eulaLink": "Sluttbrukerlisensavtalen",
    "register.freePlanNote": "Du vil bli registrert på gratisplanen. Du kan oppgradere når som helst etter registrering.",
    "register.creating": "Oppretter konto...",
    "register.createAccount": "Opprett konto",
    "register.name": "Navn",
    "register.email": "E-post",
    "register.companyName": "Firmanavn",
    "register.country": "Land",
    "register.password": "Passord",
    "register.confirmPassword": "Bekreft passord",
    "register.subtitle": "Fyll inn dine detaljer for å komme i gang",
    "register.brandTagline": "Ta kontroll over kontrakter og abonnementer",
    "register.haveAccount": "Har du allerede en konto?",
    "register.signIn": "Logg inn",
    "register.referralInvite": "Du registrerer deg via en invitasjonslenke",
    "register.benefit.secure": "Sikkerhet på banknivå og kryptering",
    "register.benefit.analytics": "Kraftig kontraktsanalyse",
    "register.benefit.reminders": "Smarte fornyelsespåminnelser",
    "register.benefit.import": "Enkel Excel-import og eksport",
    "register.plan.choosePlan": "Velg abonnement",
    "register.plan.free": "Gratis",
    "register.plan.unlimitedContracts": "Ubegrenset kontrakter",
    "register.plan.contractsCount": "{{count}} kontrakter",
    "register.plan.dashboard": "Dashboard",
    "register.plan.advancedDashboard": "Avansert dashboard",
    "register.plan.erpIntegration": "ERP-integrasjon",
    "register.plan.docExtractions": "{{count}} dok.uttrekk/mnd",
    "register.plan.customFields": "Egendefinerte felt",
    "register.plan.contractNotes": "Kontraktsnotater",
    "register.plan.duplicateDetection": "Duplikatdeteksjon",
    "register.plan.calendarView": "Kalendervisning",
    "register.plan.apiAccess": "API-tilgang",
    "register.plan.apiWrite": "API-skrivetilgang",
    "register.plan.reminders": "E-postpåminnelser",
    "register.plan.showFeatures": "Vis funksjoner",
    "register.plan.hideFeatures": "Skjul funksjoner",
    "register.plan.changeLater": "Du kan endre abonnement når som helst",
    "register.plan.selectCountryFirst": "Velg et land for å se tilgjengelige abonnementer",
    "register.plan.noPlans": "Ingen abonnementer tilgjengelig i din region ennå",
    "register.plan.popular": "Populær",
    "country.selectCountry": "Velg land",
    "country.searchCountry": "Søk etter land...",
    "country.noResults": "Ingen land funnet",
    
    // Login page
    "login.welcomeBack": "Velkommen tilbake",
    "login.subtitle": "Logg inn for å få tilgang til kontoen din",
    "login.forgotPassword": "Glemt passord?",
    "login.signingIn": "Logger inn...",
    "login.signIn": "Logg inn",
    "login.noAccount": "Har du ikke en konto?",
    "login.signUp": "Registrer deg",
    "login.trustedBy": "Klarert av bedrifter over hele Norge og utover",

    // Navigation
    "goToDashboard": "Gå til dashboard",
    "login": "Logg inn",
    "signup": "Registrer deg",
    
    // Common actions
    "cancel": "Avbryt",

    // Admin impersonation
    "admin.impersonate.title": "Logg inn som bruker",
    "admin.impersonate.confirmation": "Du er i ferd med å logge inn som {{name}} i en ny fane. Denne handlingen vil bli logget.",
    "admin.impersonate.warning1": "En ny nettleserfane åpnes med en støtteøkt",
    "admin.impersonate.warning2": "Alle handlinger under representasjon logges",
    "admin.impersonate.warning3": "Din admin-økt i denne fanen forblir aktiv",
    "admin.impersonate.confirm": "Åpne støtteøkt",
    "admin.impersonate.error": "Representasjonsfeil",
    "admin.impersonate.noSession": "Ingen aktiv admin-økt funnet.",
    "admin.impersonate.failed": "Kunne ikke starte representasjonsøkt.",
    "admin.impersonate.success": "Støtteøkt startet",
    "admin.impersonate.openedTab": "En ny fane er åpnet som {{name}}.",
    "admin.impersonate.bannerText": "Støtteøkt — viser som {{name}} ({{email}})",
    "admin.impersonate.endSession": "Avslutt økt",
    "admin.impersonate.resetDefaults": "Tilbakestill til standard",
    "admin.impersonate.resetSuccess": "Bruker tilbakestilt",
    "admin.impersonate.resetSuccessDesc": "All data er slettet og demodata er fylt inn på nytt.",
    "admin.impersonate.resetError": "Kunne ikke tilbakestille brukerdata",
    "deleting": "Sletter...",
    "deleteAll": "Slett alle",
    "more": "flere",
    "month": "måned",
    "expires": "Utløper",
    
    // Tripletex Help Dialog
    "tripletexHelp.copied": "Kopiert!",
    "tripletexHelp.copiedDescription": "Applikasjonsnavn kopiert til utklippstavlen",
    "tripletexHelp.howToCreateToken": "Hvordan oppretter jeg en brukernøkkel?",
    "tripletexHelp.title": "Hvordan oppretter du en API-brukernøkkel i Tripletex",
    "tripletexHelp.description": "Følg disse stegene for å opprette en brukernøkkel for å koble Subtrackr til din Tripletex-konto.",
    "tripletexHelp.intro": "For å koble til en integrasjon i Tripletex bruker du en unik API-brukernøkkel. Nøkkelen opprettes på en ansatt eller kontakt i bedriften og gis til integrasjonspartneren.",
    "tripletexHelp.accessNote": "Nøkkelen kan kun ha samme eller mindre tilgang til systemet som brukeren du oppretter nøkkelen på har. I tillegg må du være brukeradministrator for å se fanen \"API-tilgang\".",
    "tripletexHelp.stepsTitle": "Slik oppretter du en API-brukernøkkel:",
    "tripletexHelp.step1": "Gå til \"Lønn > Ansatte\" eller \"Kunde > Kontakter\" i hovedmenyen, og velg brukeren du ønsker å registrere nøkkelen på.",
    "tripletexHelp.step2": "Velg fanen \"API-tilgang\". Du kan også finne denne fanen på deg selv.",
    "tripletexHelp.step3": "Registrer en nøkkel ved å klikke \"Ny nøkkel\".",
    "tripletexHelp.setupTitle": "Oppsett av nøkkel:",
    "tripletexHelp.setup1": "Velg integrasjonen i feltet \"Applikasjon\". Hvis du finner integrasjonen i rullegardinen, kan du fortsette til steg 4. Hvis du IKKE finner applikasjonen, fortsetter du til steg 2 og 3.",
    "tripletexHelp.setup2": "Huk av for \"Tilpasset oppsett\" og velg hvilke type tilganger du ønsker å gi integrasjonen.",
    "tripletexHelp.setup3": "Skriv inn applikasjonsnavn i feltet \"Applikasjonsnavn\". Pass på å skrive det nøyaktig slik som vist nedenfor, og ta hensyn til små og store bokstaver:",
    "tripletexHelp.setup4": "Legg inn hva du ønsker å kalle integrasjonen i feltet \"Gi nøkkelen et navn\".",
    "tripletexHelp.setup5": "Klikk på \"Opprett nøkkel\" for å få opp den unike brukernøkkelen.",
    "tripletexHelp.accessOptionsTitle": "Tilgangsalternativer:",
    "tripletexHelp.allAccess": "Full tilgang",
    "tripletexHelp.allAccessDesc": "Dette alternativet gir nøkkelen full tilgang, men vil være begrenset til tilgangen brukeren har. I dette tilfellet må du gi brukeren mer tilgang, eller velge en annen bruker med tilgangen nøkkelen trenger.",
    "tripletexHelp.userAccess": "Gi nøkkelen denne brukerens tilgang",
    "tripletexHelp.userAccessDesc": "Dette alternativet gir nøkkelen all tilgang som brukeren har på det tidspunktet nøkkelen opprettes.",
    "tripletexHelp.customAccess": "Bestem selv",
    "tripletexHelp.customAccessDesc": "Dette alternativet gir ingen tilgang til integrasjonen. Du kan legge til tilgang til integrasjonen etterpå.",
    "tripletexHelp.importantNote": "Viktig: Brukernøkkelen vises kun én gang. Du er ansvarlig for å oppbevare den trygt.",
    "tripletexHelp.officialDocs": "Se offisiell Tripletex-dokumentasjon"
  },

  contractTypes: {
    subscription: {
      name: "Abonnement",
      description: "En gjentakende kontrakt med regelmessige betalinger"
    },
    serviceAgreement: {
      name: "Tjenesteavtale",
      description: "Kontrakt for levering av tjenester"
    },
    license: {
      name: "Lisensavtale",
      description: "Kontrakt for bruk av immaterielle rettigheter"
    },
    onetime: {
      name: "Engangskjøp",
      description: "Enkelt kjøp uten fornyelse"
    },
    lease: {
      name: "Leie/Utleie",
      description: "Kontrakt for leie av eiendom eller utstyr"
    },
    sales: {
      name: "Salgskontrakt",
      description: "Kontrakt for salg av produkter eller tjenester"
    },
    employment: {
      name: "Arbeidskontrakt",
      description: "Kontrakt med ansatte"
    },
    intro: "Kontraktstyper hjelper deg å kategorisere avtalene dine og anvende konsistente regler. Hver type kan ha spesifikke innstillinger for fornyelse og retning/formål.",
    empty: "Du har ingen kontraktstyper ennå. Legg til standardtyper eller opprett dine egne.",
    addingDefaults: "Legger til standarder...",
    addDefaults: "Legg til Standard Kontraktstyper",
    createManually: "Opprett Type Manuelt",
    yourTypes: "Dine Kontraktstyper",
    count: "Du har {{count}} kontrakttype(r)"
  },

  categories: {
    software: {
      name: "Programvare",
      description: "Programvarelisenser og abonnementer"
    },
    hardware: {
      name: "Maskinvare",
      description: "Fysisk maskinvare og utstyr"
    },
    services: {
      name: "Tjenester",
      description: "Profesjonelle og konsulenttjenester"
    },
    utilities: {
      name: "Forsyninger",
      description: "Forsyninger som elektrisitet, vann osv."
    },
    rent: {
      name: "Leie",
      description: "Kontor- og arbeidsplassleie"
    },
    intro: "Kategorier hjelper deg å organisere kontraktene dine og filtrere dem mer effektivt. Legg til kategorier som passer din organisasjons behov.",
    noCategories: "Ingen Kategorier Ennå",
    empty: "Du har ikke opprettet noen kategorier ennå. Legg til noen for å hjelpe med å organisere kontraktene dine.",
    addDefaults: "Legg til Standardkategorier",
    createCustom: "Opprett Tilpasset Kategori"
  },

  idura: {
    title: "Send for digital signering",
    description: "Send kontrakt for signering via norsk BankID",
    selectDocument: "Velg dokument",
    selectDocumentPlaceholder: "Velg et PDF-dokument...",
    signerName: "Signatarens navn",
    signerNamePlaceholder: "Skriv inn signatarens fulle navn",
    signerEmail: "Signatarens e-post",
    signerEmailPlaceholder: "Skriv inn signatarens e-postadresse",
    sendForSignature: "Send for signering (BankID)",
    sending: "Oppretter signeringsforespørsel...",
    sentSuccess: "Signeringsforespørsel sendt til {{email}}",
    sentSuccessMessage: "Signeringsforespørselen er opprettet. Del lenken nedenfor med signataren.",
    copyLink: "Kopier signeringslenke",
    copyLinkTooltip: "Kopier signeringslenken for å dele med signataren",
    openLink: "Åpne signeringslenke",
    linkCopied: "Signeringslenke kopiert til utklippstavlen",
    linkInstructions: "Send denne lenken til signataren. De vil autentisere seg med BankID for å signere dokumentet.",
    signedWith: "Signert med BankID",
    provider: "Leverandør",
    signingLink: "Signeringslenke",
    bankIdInfo: "Signataren vil autentisere seg med norsk BankID for å signere dokumentet digitalt.",
    noPdfAttachments: "Ingen PDF-dokumenter er vedlagt denne kontrakten. Vennligst legg til et PDF-dokument først.",
    validation: {
      missingFields: "Vennligst fyll ut alle påkrevde felt",
      invalidEmail: "Vennligst skriv inn en gyldig e-postadresse"
    },
    error: {
      sendFailed: "Kunne ikke sende dokument for signering"
    },
    status: {
      pending: "Venter på signatur",
      signed: "Signert",
      rejected: "Avvist",
      expired: "Utløpt"
    },
    downloadSigned: "Last ned signert",
    downloadSignedTooltip: "Last ned signert PDF med BankID-signatur",
    downloadSuccess: "Signert dokument lastet ned",
    downloadFailed: "Kunne ikke laste ned signert dokument",
    noSignedDocument: "Ingen signert dokument tilgjengelig"
  },

  // Multi-signer shared translations
  signing: {
    signers: "Signatarer",
    suggestedContacts: "Foreslått fra kontraktkontakter",
    addSigner: "Legg til signatar",
    addSignerButton: "Legg til signatar",
    namePlaceholder: "Fullt navn",
    emailPlaceholder: "E-postadresse",
    fromContacts: "Kontakt",
    noSignersYet: "Legg til minst én signatar for å fortsette",
  },

  // E-Signature (shared translations for both providers)
  esignature: {
    title: "Send for e-signatur",
    description: "Send et kontraktsdokument for elektronisk signering via DocuSign.",
    requests: "Signeringsforespørsler",
    sentTo: "Sendt til",
    signedOn: "Signert",
    selectDocument: "Velg dokument",
    selectDocumentPlaceholder: "Velg et dokument å signere",
    noDocuments: "Ingen signerbare dokumenter tilgjengelig",
    uploadHint: "Last opp et PDF- eller Word-dokument til denne kontrakten først.",
    signerName: "Signatarens navn",
    signerNamePlaceholder: "Ola Nordmann",
    signerEmail: "Signatarens e-post",
    signerEmailPlaceholder: "ola@example.com",
    emailSubject: "E-postemne",
    emailMessage: "E-postmelding",
    sendForSignature: "Send for signering",
    sendForSignatureBankID: "Send for signering (BankID)",
    sendForSignatureDocuSign: "Send for signering (DocuSign)",
    sending: "Sender...",
    validationError: "Vennligst fyll ut alle påkrevde felt",
    invalidEmail: "Vennligst skriv inn en gyldig e-postadresse",
    sentSuccess: "Dokument sendt for signering til {{email}}",
    sendError: "Kunne ikke sende dokument for signering: {{message}}",
    status: {
      completed: "Signert",
      pending: "Venter",
      declined: "Avvist",
      voided: "Annullert"
    },
    downloadSigned: "Last ned signert",
    downloadSignedTooltipBankId: "Last ned signert PDF med BankID-signatur",
    downloadSignedTooltipDocuSign: "Last ned signert PDF fra DocuSign",
    downloadSuccess: "Signert dokument lastet ned",
    downloadFailed: "Kunne ikke laste ned signert dokument",
    noSignedDocument: "Ingen signert dokument tilgjengelig",
    declineReason: "Årsak",
    noDeclineReason: "Ingen årsak oppgitt",
    limitReached: "Du har nådd signeringsgrensen for denne måneden.",
    buyCredits: "Kjøp kreditter"
  },

  // Signing Integrations Admin
  signingIntegrations: {
    title: "Signeringsintegrasjoner",
    description: "Administrer signeringsleverandører og deres miljømoduser",
    criiptoName: "Criipto (BankID)",
    criiptoDescription: "Norsk BankID digitale signaturer for nordiske kontrakter",
    docusignName: "DocuSign",
    docusignDescription: "Internasjonal e-signaturtjeneste for globale kontrakter",
    enabled: "Aktivert",
    disabled: "Deaktivert",
    production: "Produksjon",
    development: "Utvikling",
    environment: "Miljø",
    productionDesc: "Bruker ekte API-endepunkter og belaster reelle kostnader",
    developDesc: "Bruker sandbox/demo-endepunkter og simulerte kostnader",
    productionWarning: "Produksjonsmodus er aktiv. Alle signeringsforespørsler bruker ekte API-endepunkter og medfører reelle kostnader.",
    providerEnabled: "Leverandør aktivert",
    providerDisabled: "Leverandør deaktivert",
    providerEnabledDesc: "Brukere kan nå bruke denne signeringsleverandøren",
    providerDisabledDesc: "Denne signeringsleverandøren er nå skjult for brukere",
    modeUpdated: "Modus oppdatert",
    productionModeActive: "Produksjonsmodus er nå aktiv. Ekte API-endepunkter og kostnader vil bli brukt.",
    developModeActive: "Utviklingsmodus er nå aktiv. Sandbox-endepunkter og simulerte kostnader vil bli brukt.",
    updateFailed: "Kunne ikke oppdatere innstilling",
    confirmProductionTitle: "Bytte til produksjonsmodus?",
    confirmProductionDesc: "Å bytte til produksjonsmodus betyr:",
    confirmPoint1: "Ekte API-endepunkter vil bli brukt for signeringsforespørsler",
    confirmPoint2: "Kjøp av signeringskreditter vil medføre ekte Stripe-kostnader",
    confirmPoint3: "Alle signaturer vil være juridisk bindende",
    confirmSwitch: "Bytt til produksjon",
    note: "Når en leverandør er deaktivert, vil brukere ikke se signeringsknappen for den leverandøren. Utviklingsmodus bruker sandbox-endepunkter og simulerer kredittidlkjøp.",
    accessSettings: "Tilgangsinnstillinger",
    accessDescription: "Konfigurer hvem som kan bruke denne signeringsleverandøren",
    accessMode: "Tilgangsmodus",
    allUsers: "Alle brukere",
    restrictedAccess: "Begrenset tilgang",
    allUsersDesc: "Alle brukere med signeringstilgang i abonnementet kan bruke denne leverandøren",
    restrictedDesc: "Kun utvalgte roller og brukere kan bruke denne signeringsleverandøren",
    allowedRoles: "Tillatte roller",
    allowedUsers: "Tillatte brukere",
    searchUsers: "Søk etter brukere med navn eller e-post...",
    noUsersFound: "Ingen brukere funnet",
    saveAccess: "Lagre endringer",
    access: "Tilgang",
    restricted: "Begrenset",
    accessUpdated: "Tilgangsinnstillinger oppdatert",
    accessUpdatedDesc: "Tilgangsinnstillingene for signeringsleverandøren er lagret",
  },

  subscription: {
    usage: {
      title: "Bruk og grenser",
      description: "Følg med på bruken din mot plangrensene dine",
      contracts: "Kontrakter",
      documentExtractions: "Dokumentuttrekk",
      signings: "Kontraktsigneringer",
      erpIntegrations: "ERP-integrasjoner",
      storage: "Lagring",
      includesAddons: "Inkluderer {{count}} tilleggskreditter",
      monthlyReset: "Nullstilles månedlig"
    },
    limits: {
      contractLockedRow: "Låst — over plangrense",
      contractLockedTooltip: "Denne kontrakten overstiger plangrensen din ({{used}}/{{limit}}). Oppgrader planen eller slett andre kontrakter for å låse den opp.",
      contractLockedTitle: "Kontrakt låst",
      contractLockedMessage: "Du har {{used}} kontrakter, men planen din tillater bare {{limit}}. De nyeste kontraktene er låst inntil du oppgraderer planen eller sletter andre kontrakter. Du kan fortsatt slette denne kontrakten."
    }
  },
  addOns: {
    buyExtractions: "Kjøp dokumentuttrekk",
    extractionsDescription: "Kjøp ekstra dokumentuttrekkskreditter som aldri utløper.",
    extractionsCount: "{{count}} uttrekk",
    perExtraction: "uttrekk",
    buySignings: "Kjøp signeringskreditter",
    signingsDescription: "Kjøp ekstra e-signaturkreditter som aldri utløper.",
    signingsCount: "{{count}} signeringer",
    perSigning: "signering",
    bestValue: "Beste verdi",
    purchase: "Kjøp",
    purchaseFailed: "Kjøpet feilet. Vennligst prøv igjen.",
    redirectingToCheckout: "Videresender til betaling...",
    simulatedPurchaseSuccess: "Utviklingsmodus: {{credits}} signeringskreditter lagt til (ingen kostnad)"
  },
  attachments: {
    title: "Vedlegg",
    description: "Dokumenter relatert til denne kontrakten",
    upload: "Last opp",
    uploading: "Laster opp...",
    noAttachments: "Ingen vedlegg lastet opp",
    addAttachments: "Legg til vedlegg",
    view: "Vis",
    download: "Last ned",
    downloading: "Laster ned",
    opening: "Åpner",
    downloadError: "Kunne ikke laste ned filen. Vennligst prøv igjen.",
    openError: "Kunne ikke åpne filen. Vennligst prøv å laste ned i stedet.",
    uploadSuccess: "Filer lastet opp",
    uploadError: "Kunne ikke laste opp filer. Vennligst prøv igjen.",
    uploadFileError: "Feil ved opplasting av fil",
    saveError: "Feil ved lagring av vedlegg",
    authError: "Du må være innlogget for å laste opp filer.",
    delete: "Slett",
    deleting: "Sletter...",
    deleteTitle: "Slett vedlegg",
    deleteConfirm: "Er du sikker på at du vil slette \"{name}\"? Denne handlingen kan ikke angres.",
    deleteSuccess: "Vedlegg slettet",
    deleteError: "Kunne ikke slette vedlegg"
  },
  // Contract Document Builder
  contractDocuments: {
    templatesTitle: "Dokumentmaler",
    templatesDescription: "Opprett gjenbrukbare maler for kontraktsdokumentene dine",
    newTemplate: "Ny mal",
    editTemplate: "Rediger mal",
    noTemplates: "Ingen maler ennå",
    noTemplatesDesc: "Opprett din første dokumentmal for å begynne å generere profesjonelle kontraktsdokumenter.",
    createFirst: "Opprett din første mal",
    templateName: "Malnavn",
    templateContent: "Malinnhold",
    insertVariable: "Sett inn variabel",
    editorPlaceholder: "Begynn å skrive kontraktsdokumentet ditt...",
    // Phase 2
    documentsTitle: "Dokumenter",
    documentsDescription: "Kontraktsdokumenter og utkast",
    createDocument: "Opprett dokument",
    noDocuments: "Ingen dokumenter ennå",
    noDocumentsDesc: "Opprett et dokument fra en mal eller start fra bunnen av.",
    document: "Dokument",
    documentCreateError: "Kunne ikke opprette dokument.",
    documentDeleteError: "Kunne ikke slette dokument.",
    pdfError: "Kunne ikke generere PDF.",
    documentDeleted: "Dokument slettet",
    documentDeletedDesc: "Dokumentet har blitt fjernet.",
    deleteDocumentTitle: "Slette dokument?",
    deleteDocumentDesc: "Denne handlingen kan ikke angres. Dokumentet vil bli permanent slettet.",
    selectTemplate: "Velg mal",
    selectTemplateDesc: "Velg en mal for å opprette et forhåndsutfylt dokument, eller start med et blankt dokument.",
    choosePlaceholder: "Velg en mal...",
    default: "standard",
    blankDocument: "Blankt dokument",
    useTemplate: "Bruk mal",
    downloadPdf: "Last ned PDF",
    finalize: "Fullfør",
    saved: "Dokument lagret",
    savedDesc: "Endringene dine er lagret.",
    finalized: "Dokument fullført",
    finalizedDesc: "Dokumentet er markert som fullført.",
    unsaved: "Ulagrede endringer",
    untitledDocument: "Dokument uten tittel",
    documentNotFound: "Dokument ikke funnet",
    goBack: "Gå tilbake",
    lastUpdated: "Oppdatert",
    status: {
      draft: "Utkast",
      finalized: "Fullført",
      sent_for_signing: "Sendt til signering",
      signed: "Signert",
    },
    // Phase 3: Clause Library
    clauseLibrary: "Klausulbibliotek",
    clauseLibraryDesc: "Bla gjennom og sett inn gjenbrukbare klausuler i dokumentet ditt.",
    clauseLibraryPageDesc: "Administrer gjenbrukbare klausuler for kontraktsdokumentene dine.",
    insertClause: "Sett inn",
    newClause: "Ny klausul",
    editClause: "Rediger klausul",
    clauseFormDesc: "Opprett en gjenbrukbar klausul for kontraktsdokumentene dine.",
    clauseName: "Klausulnavn",
    clauseNamePlaceholder: "f.eks. Konfidensialitetsklausul",
    clauseCategoryLabel: "Kategori",
    clauseContent: "Klausulinnhold",
    clauseContentPlaceholder: "Skriv klausulinnholdet her...",
    clauseNameRequired: "Klausulnavn er påkrevd.",
    clauseCreated: "Klausul opprettet",
    clauseCreatedDesc: "Klausulen er lagt til i biblioteket ditt.",
    clauseUpdated: "Klausul oppdatert",
    clauseUpdatedDesc: "Klausulen er lagret.",
    clauseDeleted: "Klausul slettet",
    clauseDeletedDesc: "Klausulen har blitt fjernet.",
    clauseSaveError: "Kunne ikke lagre klausul.",
    clauseDeleteError: "Kunne ikke slette klausul.",
    deleteClauseTitle: "Slette klausul?",
    deleteClauseDesc: "Denne handlingen kan ikke angres. Klausulen vil bli permanent fjernet fra biblioteket ditt.",
    noClausesYet: "Ingen klausuler i biblioteket ditt ennå.",
    noClausesDesc: "Administrer klausuler fra Klausulbibliotek-siden i innstillinger.",
    noClausesPageDesc: "Opprett gjenbrukbare klausuler som du kan sette inn i ethvert kontraktsdokument.",
    createFirstClause: "Opprett din første klausul",
    clauseCategory: {
      general: "Generelt",
      legal: "Juridisk",
      financial: "Økonomi",
      termination: "Oppsigelse",
      confidentiality: "Konfidensialitet",
      liability: "Ansvar",
      other: "Annet",
    },
    signingPrepError: "Kunne ikke forberede dokument for signering.",
    preparingSigning: "Forbereder...",
    sendForSigningBankID: "Send til signering (BankID)",
    sendForSigningDocuSign: "Send til signering (DocuSign)",
    sentForSigning: "Sendt til signering",
    sentForSigningDesc: "Dokumentet er sendt til e-signatur.",
    importDocument: {
      title: "Importer dokument",
      buttonLabel: "Importer",
      description: "Last opp en PDF, DOC, DOCX, eller bildefil for å konvertere den til redigerbart innhold.",
      dropzone: "Klikk for å velge en fil",
      converting: "Konverterer...",
      convert: "Importer til editor",
      success: "Dokument importert",
      successDesc: "Dokumentinnholdet er lagt til i editoren.",
      conversionError: "Kunne ikke konvertere dokument. Prøv igjen.",
      fileTooLarge: "Filen er for stor. Maksimal størrelse er 10MB.",
      unsupportedFormat: "Filformatet støttes ikke. Bruk PDF, DOC, DOCX, eller bildefiler.",
      hint: "DOCX-filer konverteres lokalt for best kvalitet. PDF- og bildefiler bruker AI for å trekke ut og strukturere innholdet.",
      rateLimited: "For mange forespørsler. Vent litt og prøv igjen.",
      creditsExhausted: "AI-kreditter er brukt opp. Legg til flere kreditter for å fortsette.",
    },
    versionHistory: "Versjonshistorikk",
    createNewVersion: "Ny versjon",
    newVersionCreated: "Ny versjon opprettet",
    newVersionCreatedDesc: "En ny utkastversjon er opprettet.",
    newVersionError: "Kunne ikke opprette ny versjon.",
    editedBy: "Redigert av",
    downloadSignedDoc: "Last ned signert dokument",
    lockedMessage: "Denne versjonen er låst fordi den er sendt til signering eller signert. Opprett en ny versjon for å gjøre endringer.",
  },
  portfolioAssessment: {
    title: "Porteføljevurdering",
    description: "Helhetlig oversikt over kontraktporteføljens tilstand",
    maturityScore: "Kontraktmodenhet",
    outOf: "av 100",
    scoreExcellent: "Utmerket",
    scoreGood: "Bra",
    scoreFair: "Akseptabelt",
    scorePoor: "Trenger forbedring",
    generateReport: "Generer PDF-rapport",
    shareReport: "Del rapport",
    keyFindings: "Hovedfunn",
    expirationTimeline: "Utløpstidslinje",
    noData: "Ingen kontraktsdata tilgjengelig",
    shareTitle: "Del vurderingsrapport",
    shareDescription: "Opprett en tidsbegrenset lenke som hvem som helst kan bruke for å se denne rapporten uten å logge inn.",
    shareLinkExpiry: "Lenken utløper etter",
    shareExpiry24h: "24 timer",
    shareExpiry72h: "3 dager",
    shareExpiry7d: "7 dager",
    shareExpiry30d: "30 dager",
    shareGenerate: "Generer delingslenke",
    shareLinkLabel: "Delingslenke",
    shareLinkCopied: "Lenke kopiert til utklippstavle",
    shareLinkCreated: "Delingslenke opprettet",
    shareError: "Kunne ikke generere delingslenke",
    shareAuthError: "Autentisering kreves",
    shareExpiresAt: "Utløper",
    industryBenchmark: "Bransjebenchmark",
    yourScore: "Din score",
    industryAvg: "Bransjegjennomsnitt",
    scoreTrend: "Score-utvikling",
    sinceStart: "siden start",
    trendNoData: "Score-historikk vises her etter neste vurdering. Scores registreres daglig.",
    aiSummary: "AI-sammendrag",
    aiGenerate: "Generer sammendrag",
    aiRegenerate: "Generer på nytt",
    aiSummaryHint: "Klikk \"Generer sammendrag\" for å lage en AI-drevet oppsummering av porteføljevurderingen.",
    aiGenerating: "Analyserer porteføljedata...",
    aiSummaryError: "Kunne ikke generere sammendrag. Vennligst prøv igjen.",
  },
  sharedReport: {
    sharedAssessment: "Delt porteføljevurdering",
    generatedOn: "Generert",
    poweredBy: "Drevet av Subtrackr — Kontrakthåndteringsplattform",
    expiredTitle: "Rapportlenken har utløpt",
    expiredDesc: "Denne rapportlenken har utløpt. Be eieren om en ny lenke.",
    revokedTitle: "Rapportlenken er tilbakekalt",
    revokedDesc: "Denne rapportlenken er tilbakekalt av eieren.",
    notFoundTitle: "Rapport ikke funnet",
    notFoundDesc: "Denne rapporten ble ikke funnet. Lenken kan være ugyldig.",
    errorTitle: "Noe gikk galt",
    errorDesc: "En feil oppstod under lasting av rapporten. Vennligst prøv igjen senere.",
  },
  advisorAccess: {
    title: "Rådgivertilgang",
    description: "Inviter eksterne konsulenter eller investorer til å gjennomgå kontraktporteføljen din med lesetilgang.",
    inviteAdvisor: "Inviter rådgiver",
    email: "E-postadresse",
    accessLevel: "Tilgangsnivå",
    readOnly: "Kun lesetilgang",
    analyst: "Analytiker (les + analyser)",
    accountant: "Regnskapsfører",
    auditor: "Revisor",
    duration: "Tilgangsvarighet",
    days30: "30 dager",
    days60: "60 dager",
    days90: "90 dager",
    sendInvite: "Send invitasjon",
    inviteSent: "Invitasjon sendt",
    inviteError: "Kunne ikke sende invitasjon",
    currentAdvisors: "Nåværende rådgivere",
    noAdvisors: "Ingen rådgivere har blitt invitert ennå.",
    expiresOn: "Utløper",
    active: "Aktiv",
    pending: "Venter",
    expired: "Utløpt",
    revoked: "Tilbakekalt",
    revokeTitle: "Tilbakekall rådgivertilgang",
    revokeDescription: "Er du sikker på at du vil tilbakekalle tilgangen for {{email}}?",
    revokeConfirm: "Tilbakekall tilgang",
    revokeError: "Kunne ikke tilbakekalle tilgang",
    acceptSuccess: "Invitasjon godtatt!",
    acceptSuccessDesc: "Du har nå rådgivertilgang til å gjennomgå kontraktporteføljen.",
    acceptError: "Invitasjonsfeil",
    goToDashboard: "Gå til rådgiver-dashboard",
  },
  advisorDashboard: {
    title: "Rådgiver-dashboard",
    description: "Lesetilgang til kontraktporteføljen",
    selectWorkspace: "Velg arbeidsområde",
    loadingClient: "Laster klient…",
    clientNumber: "Klient {{number}}",
    memberBadge: "Medlem ({{role}})",
    noAccess: "Ingen aktiv rådgivertilgang",
    noAccessDesc: "Du har ingen aktive rådgiverengasjement. Be en kontoeier om å invitere deg.",
  },
  bureauCockpit: {
    nav: "Cockpit",
    title: "Byrå-cockpit for kontrakter",
    subtitle: "Tverrgående kontrakt- og kostnadsoversikt for hele rådgivningsporteføljen.",
    loadingClients: "Laster klientdata…",
    noAccessTitle: "Ingen aktive klientengasjement",
    noAccessDesc: "Byrå-cockpit aggregerer kontraktdata på tvers av alle klient-workspaces du har aktiv rådgivertilgang til. Be en arbeidsområde-eier invitere deg som rådgiver for å komme i gang.",
    clientFallback: "Klient",
    kpi: {
      clients: "Klienter",
      contractsAcross: "{{count}} kontrakter på tvers av porteføljen",
      totalSpend: "Total årlig kostnad",
      aggregated: "Aggregert på tvers av alle klienter",
      savings: "Besparingspotensial",
      savingsDesc: "AI-identifisert på tvers av alle klientporteføljer",
      maturity: "Snitt modenhetsscore",
      maturityScale: "Av 100",
    },
    renewals: {
      title: "Kommende fornyelser på tvers av klienter",
      next30: "Neste 30 dager",
      next60: "Neste 60 dager",
      next90: "Neste 90 dager",
    },
    risk: {
      title: "Klienter med høyrisiko-kontrakter",
      ofTotal: "av {{total}} klienter",
      desc: "Klienter med én eller flere kontrakter merket som høy eller kritisk risiko.",
    },
    table: {
      title: "Klientportefølje",
      search: "Søk i klienter…",
      client: "Klient",
      contracts: "Kontrakter",
      spend: "Årlig kostnad",
      savings: "Besparelse",
      maturity: "Modenhet",
      expiring30: "Utløp 30d",
      empty: "Ingen klienter matcher filteret ditt.",
      open: "Åpne klient-dashboard",
    },
    toolsDesc: "Tverrgående kontrakt- og kostnadsoversikt",
    badge: {
      multiEntity: "Flere selskap",
    },
    source: {
      member: "Medlem ({{role}})",
    },
  },
};
